<div class="image-container">
  <app-drawing-library-image-preview [drawingImage]="image" shouldDownloadImage="false"></app-drawing-library-image-preview>
</div>

<div class="info-container" [style.height]="getPopupHeight()">
  <div class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.PATH_NUMBER' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ number }}</div>
  </div>
  <div class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'DESIGN_LIBRARY.DETAILS.DESIGN_NAME' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ drawingName }}</div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_BAR)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'ORDERBOOK.QUANTITY' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ quantity }}</div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_DESIGN)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'SUPPORT.MACHINES_LIST.TABLE_HEADER.MACHINE_QUALITY' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ quality }}</div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_DESIGN)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'PRODUCTION_ORDER.DESIGN_LIBRARY.COLOR_SET' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">
      <app-color-list-preview-with-position #colorListPreviewComponents [isSisal]="isSisal" [coloredYarnSet]="coloredYarnSet" [creelMapping]="creelMapping"></app-color-list-preview-with-position>
    </div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_DESIGN)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'DESIGN_LIBRARY.DETAILS.COLOR_MAIN' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">
      <app-color-grid-preview [colors]="getColorByPosition(mainColorPosition)" [showRgbValues]="false" [showLabel]="false" class="full-width"></app-color-grid-preview>
    </div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_DESIGN)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'DESIGN_LIBRARY.DETAILS.COLOR_BORDER' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">
      <app-color-grid-preview [colors]="getColorByPosition(borderColorPosition)" [showRgbValues]="false" [showLabel]="false" class="full-width"></app-color-grid-preview>
    </div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_DESIGN)" class="info-entry info-entry--large flex-row full-width">
    <div class="title b2 regular">{{ 'GENERAL.DIMENSIONS.DIMENSIONS' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">
      <span class="mb-4">{{ widthInDents }}x{{ heightInPicks }} {{ 'GENERAL.UNIT.DENTS' | bmsTranslate }}/{{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}</span>
      <span>{{ width }}x{{ length }} cm</span>
    </div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_DESIGN)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'GENERAL.SHAPE' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ shape | titlecase }}</div>
  </div>
  <div class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'TEXTILE_DATA.FINISHING.FINISHING' | bmsTranslate: {count: 1} }}</div>
    <div class="content b2 font-weight-semibold">{{ finishingName?.split(' ')?.join('') }}</div>
  </div>
  <div *ngIf="hasCutBarBefore()" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'TEXTILE_DATA.FINISHING_TEMPLATE.LABEL.PLACE_OPTIONS.CUTBAR_BEFORE' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ cutbarBefore }}mm/{{ cutbarBeforeInPicks }}{{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}</div>
  </div>
  <div *ngIf="hasCutBarAfter()" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'TEXTILE_DATA.FINISHING_TEMPLATE.LABEL.PLACE_OPTIONS.CUTBAR_AFTER' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ cutbarAfter }}mm/{{ cutbarAfterInPicks }}{{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}</div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_DESIGN)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'ORDERBOOK.NUMBER_OF_PIECES' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ numberOfPieces }}</div>
  </div>
  <div class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'SALES.TITLE' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ sales }}</div>
  </div>
  <div class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'SALES_ORDERS.ORDER_LINES.ORDER_LINE' | bmsTranslate: {count: 1} }}</div>
    <div class="content b2 font-weight-semibold">{{ orderline }}</div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_DESIGN)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'ORDERBOOK.CUSTOMER_REFERENCE_ABBREVIATION' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ customer }}</div>
  </div>
  <div class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'GENERAL.DATETIME.DUE_DATE' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ dueDate }}</div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_BAR)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'GENERAL.DIMENSIONS.WIDTH' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ width }} cm</div>
  </div>
  <div *ngIf="canShowInfoEntry(pathItemInfoTooltipContext.PATH_BAR)" class="info-entry flex-row full-width">
    <div class="title b2 regular">{{ 'GENERAL.DIMENSIONS.LENGTH' | bmsTranslate }}</div>
    <div class="content b2 font-weight-semibold">{{ length }} cm</div>
  </div>
</div>
